import { SiteCompareDashboard } from '../components/siteCompareDashboard/siteCompareDashboard';
import { MachineDashboard } from '../components/machineDashboard/machineDashboard';
import DashboardPageHeader from '../components/machineDashboard/pageHeader';
import { SiteDashboard } from '../components/siteDashboard/siteDashboard';
import machinesIcon from '../images/machinesSideBarIcon.svg';
import sitesIcon from '../images/sitesSideBarIcon.svg';
import { Divider, Box } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
import Page from '../components/Page';
import Tab from '@mui/material/Tab';
import { useState } from 'react';
import '../css/dashboard/dashboardApp.css';

const getTabStyles = (tabValue, selectedValue) => ({
    textTransform: 'none',
    color: tabValue === selectedValue ? '#201E1E' : '#6E6D6D',
    fontWeight: '600',
    paddingBottom: 0,
    minHeight: '30px',
    fontFamily: 'Montserrat',
    fontSize: '15px',
    '&.Mui-selected': {
        color: '#201E1E',
    },
});

export const FinancialDashboard = () => {

    const [selectedTab, setSelectedTab] = useState('1');

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Page title="Tableau financier">
            <DashboardPageHeader />
            <Divider />
            <TabContext value={selectedTab}>
                <Box sx={{ display: 'flex', height: '50px', alignItems: 'center', margin: '20px' }}>
                    <TabList
                        variant="scrollable"
                        onChange={handleChange}
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: '#EE792B',
                                height: '2px',
                            },
                        }}
                        sx={{ borderBottom: '1px solid #DEDDDD', width: '100%', justifyContent: 'flex-start' }}
                    >
                        <Tab
                            value="1"
                            iconPosition="start"
                            label='Machines'
                            sx={getTabStyles('1', selectedTab)}
                            icon={<img src={machinesIcon} alt="icon" width={36} height={36} loading='lazy' decoding='async' />}
                        />
                        <Tab
                            value="2"
                            iconPosition="start"
                            label="Sites"
                            sx={getTabStyles('2', selectedTab)}
                            icon={<img src={sitesIcon} alt="icon" width={36} height={36} loading='lazy' decoding='async' />}
                        />
                        <Tab
                            value="3"
                            iconPosition="start"
                            label="Sites (Comparaison 2 ans)"
                            sx={getTabStyles('3', selectedTab)}
                            icon={<img src={sitesIcon} alt="icon" width={36} height={36} loading='lazy' decoding='async' />}
                        />
                    </TabList>
                </Box>

                <TabPanel value="1" sx={{ padding: '0px 20px 0px 20px' }}>
                    <MachineDashboard />
                </TabPanel>
                <TabPanel value="2" sx={{ padding: '0px 20px 0px 20px' }}>
                    <SiteDashboard />
                </TabPanel>
                <TabPanel value="3" sx={{ padding: '0px 20px 0px 20px' }}>
                    <SiteCompareDashboard />
                </TabPanel>
            </TabContext>
        </Page>
    );
}